var emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/**@type {import("./types").FormFieldValidator} */

export default (function (value, _ref) {
  var emailBlacklist = _ref.emailBlacklist;
  var error = 'Email address is invalid';
  if (!emailRegExp.test(value)) return error;
  if (containsBlacklistedDomain(value, emailBlacklist)) return error;
  return '';
});

var containsBlacklistedDomain = function containsBlacklistedDomain(value, emailBlacklist) {
  var domain = value.substr(value.indexOf('@') + 1).toLowerCase();
  if (emailBlacklist && emailBlacklist.toLowerCase().includes(domain)) return true;
  return false;
};